module.exports = __webpack_public_path__ + "au.95735e2022274f3c157a.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/au.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/au.svg
// module chunks = styles